module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-door-vertical-top.91bc1c8e.png";